<div class="users-scroll" #container>
	<ul class="users-list" *ngIf="items?.length; else empty">
		<li
			class="users-list__item"
			*ngFor="let item of items"
			[class.is-checked]="checkedItem(item)"
			(click)="selectedItem(item)">
			<div class="users-list__check" (click)="$event.stopPropagation(); selectedItem(item)">
				<app-icon *ngIf="checkedItem(item); else notChecked">check_box</app-icon>
				<ng-template #notChecked>
					<app-icon>check_box_outline_blank</app-icon>
				</ng-template>
			</div>
			<div class="users-list__info">
				<span class="users-list__fio">{{ item?.fullName }}</span>
				<span class="users-list__job" *ngIf="item?.jobPost">{{ item?.jobPost }}</span>
			</div>
		</li>
	</ul>
	<ng-template #empty>
		<p class="users-empty" i18n>Сотрудники не найдены</p>
	</ng-template>
</div>
